import { Component, OnInit, ViewEncapsulation, computed, inject, signal } from "@angular/core";
import { NavigationStart, Router, RouterLink, RouterLinkActive } from "@angular/router";
import { ManagementSessionCompaniesGetParameters } from "@api/model/managementSessionCompaniesGetParameters";
import { ManagementApiService } from "@api/service/management.api.service";
import { CompanyImageComponent } from "@company/components/company-image/company-image.component";
import { CompanyListComponent } from "@company/components/company-list/company-list.component";
import { CompanyService } from "@core/client/company.service";
import { OrganisationService } from "@core/client/organisation.service";
import { FeatureFlagsService } from "@core/feature-flags/page-feature-flags.service";
import { Module, Navigation, navigationItem } from "@core/navigation/navigation.model";
import { NavigationService } from "@core/navigation/navigation.service";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { OrganisationImageComponent } from "@organisation/components/organisation-image/organisation-image.component";
import { ModalComponent } from "@shared/components/modals/modal/modal.component";
import { TooltipDirective } from "@shared/directives/tooltip/tooltip.directive";
import { CompanyBarFeatureFlags, initCompanyBarFeatureFlags } from "./company-bar.features";

@Component({
    selector: 'app-company-bar',
    imports: [RouterLink, RouterLinkActive, TooltipDirective, FontAwesomeModule, ModalComponent, CompanyListComponent, CompanyImageComponent, OrganisationImageComponent],
    templateUrl: './company-bar.component.html',
    styleUrl: './company-bar.component.scss',
    encapsulation: ViewEncapsulation.None
})
export class CompanyBarComponent implements OnInit{
    Modules = Module;
    Navigation = Navigation;
    
    featureFlagsService = inject(FeatureFlagsService);
    private router = inject(Router);
    private companyService = inject(CompanyService);
    private organisationService = inject(OrganisationService);
    private navigationService = inject(NavigationService);
    private managementApiService = inject(ManagementApiService);
    
    company = computed(() => {
        return this.companyService.company();
    })
    organisation = computed(() => {
        return this.organisationService.organisation();
    })
    
    features = signal<CompanyBarFeatureFlags>(initCompanyBarFeatureFlags());
    navData = this.navigationService.navigation;
    companyNavData = signal<navigationItem|undefined>(this.navData().find((module) => module.name == Module.Company));
    organisationNavData = signal<navigationItem|undefined>(this.navData().find((module) => module.name == Module.Organisation));
    extended = signal<boolean>(false);
    companySelectVisible = signal<boolean>(false);
    filterParams = signal<Partial<ManagementSessionCompaniesGetParameters>>({});

    constructor(){
        this.featureFlagsService.featureFlags$.subscribe(() => {
            this.features.set(this.featureFlagsService.getFeatureFlags("CompanyBar"))
        })
    }

    ngOnInit(): void {
        this.router.events.subscribe((event) => {
            if(event instanceof NavigationStart){
                this.companySelectVisible.set(false);
            }
        })
    }
            
    getCompanies = (params:Partial<ManagementSessionCompaniesGetParameters>) => {
        
        return this.managementApiService.Management.Session.Companies.Get({
            params:{
                _withPagination: true,
                ...this.filterParams(),
                ...params
            }
        })

    }
    
    getCompanyChildUrl(url:any[]){
        if(url[0] == '/'){
            return url;
        }
        else{
            return ['company', this.companyService.company()?.id, ...url]
        }
    }
}
